import { fetchApi } from 'api/index'
import { SharingType } from 'components/block/SharingContent/SharingContent.constant'

export interface SharingMethod {
  sharingMethod: string
  url: string
}

export const fetchSharingUrlsListApi = (
  typeSharingContent: SharingType,
  contentId: number,
  profileId: number
) =>
  fetchApi(
    `/sharing/urls?contentIdentity[type]=${typeSharingContent}&contentIdentity[contentId]=${contentId}&contentIdentity[ownerId]=${profileId}`
  )

export const shareHitMethodStatisticsApi = (
  typeSharing: unknown,
  contentId: number,
  profileId: number,
  sharingMethod: unknown
) =>
  fetchApi('/sharing/hitShared', {
    method: 'POST',
    body: JSON.stringify({
      contentIdentity: {
        type: typeSharing,
        contentId,
        ownerId: profileId,
      },
      sharingMethod,
    }),
  })
